module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/human-a88581d46e024a652b69d8360a50f1a0.svg";